/**
 * Кнопка экспорта графика в PNG.
 * Оборачивает контейнер с графиком Recharts и позволяет скачать его как изображение.
 */

import React, { useRef } from 'react';
import html2canvas from 'html2canvas';

interface ChartExportWrapperProps {
  children: React.ReactNode;
  fileName?: string;
}

const ChartExportWrapper: React.FC<ChartExportWrapperProps> = ({ children, fileName = 'chart' }) => {
  const chartRef = useRef<HTMLDivElement>(null);

  const handleExport = async () => {
    if (!chartRef.current) return;
    try {
      const canvas = await html2canvas(chartRef.current, {
        backgroundColor: '#ffffff',
        scale: 2,
      });
      const link = document.createElement('a');
      link.download = `${fileName}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    } catch (err) {
      console.error('Ошибка экспорта графика:', err);
    }
  };

  return (
    <div>
      <div ref={chartRef}>
        {children}
      </div>
      <button onClick={handleExport} style={styles.exportBtn} title="Скачать график как PNG">
        Скачать PNG
      </button>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  exportBtn: {
    marginTop: 8,
    padding: '4px 12px',
    fontSize: 12,
    backgroundColor: 'var(--bg-btn-secondary)',
    color: 'var(--text-btn-secondary)',
    border: '1px solid var(--border-color)',
    borderRadius: 6,
    cursor: 'pointer',
  },
};

export default ChartExportWrapper;
